import { Link } from 'react-router-dom';

export default function CtaBand() {
  return (
    <section className="bg-accent-500">
      <div className="w-full px-5 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-2xl">
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-foreground-950/70">
              Business & Media
            </p>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black leading-tight text-foreground-950">
              机构媒体、研究机构与品牌合作
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-950/80">
              转载授权、联合调查、数据合作与内容共建，都可以通过商务合作通道发起。
              合作不影响议题独立性，信源信息也不会因合作而共享。
            </p>
          </div>

          <div className="flex flex-col sm:flex-row lg:flex-col gap-3 shrink-0 w-full sm:w-auto">
            <Link
              to="/cooperation"
              className="inline-flex items-center justify-center gap-2 bg-foreground-950 hover:bg-foreground-800 text-background-50 text-sm font-medium px-7 py-4 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-links-line"></i>
              查看合作方式
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 border border-foreground-950/30 hover:bg-foreground-950/10 text-foreground-950 text-sm font-medium px-7 py-4 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              提交线索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}